import { useEffect, useState } from "react";
import { GetNoticeDetailAnswereTableByGroupIdWithCompanyFilter } from "../../services/GroupService";
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { BaseGridOptions } from "../../extentions/CustomGridOptions";
import { NoneODataServerSideDatasource } from "../../extentions/NoneODataServerSideDataSource";
import axios from "axios";
import { GURL } from "../../services/global";
import { ICellRendererParams } from "ag-grid-community";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";
import { GetNoticeById } from "../../services/NoticeService";
import { GetCompanyById } from "../../services/CompanyService";
import { number } from "yup";
import { Units } from "../../helpers/Units";
import ConvertToShamsiWithOut330 from "../../extentions/convertors/ConvertToShamsiWithOut330";
import Notice from "../Notice/Notice";
import { Button as AButton } from "antd";
const CompareTableNoticeDetailsVer1 = () => {
  function getQueryStringValue(key: any) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  }

  const [CompanyId, setCompanyId] = useState<any>(null);
  const [NoticeId, setNoticeId] = useState<any>(null);
  const [data, SetData] = useState<any>();
  const [reportData, SetreportData] = useState<any>();
  const [CompanyData, setCompanyData] = useState<any>(null);
  const [SumPrice, setSumPrice] = useState<any>(null);
  const [SumTotalPrice, setTotalSumPrice] = useState<any>(null);
  const [SumVat, setSumVat] = useState<any>(null);
  const [SumTotalPriceVat, setTotalSumPriceVat] = useState<any>(null);

  function convertToPersianNumbers(number: any) {
    if (number === undefined) {
      return;
    }
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return number.toString().replace(/\d/g, (d: any) => persianDigits[d]);
  }

  useEffect(() => {
    if (
      reportData !== undefined &&
      reportData !== null &&
      data !== undefined &&
      data !== null
    ) {
      const calculatedSumPrice = reportData
        .map((item: any) => item.price)
        .reduce((a: any, b: any) => a + b, 0);
      setSumPrice(calculatedSumPrice);
      reportData.map((p: any) => {});

      //sum 2
      const calculatedSumTotalPrice = reportData.reduce(
        (acc: any, item: any) => acc + item.price * item.count,
        0
      );

      setTotalSumPrice(calculatedSumTotalPrice);

      // Sum 3
      const calculatedSumVat = reportData.reduce(
        (acc: any, item: any) => acc + Math.round(item.totalVat),
        0
      );
      setSumVat(calculatedSumVat);
      //
      const calculatedSumTotalPriceVat = reportData.reduce(
        (acc: any, item: any) => acc + item.totalPriceWithVat,
        0
      );

      setTotalSumPriceVat(calculatedSumTotalPriceVat);
    }
  }, [reportData, data]);
  const handlePrint = () => {
    window.print();
  };
  useEffect(() => {
    const companyId = getQueryStringValue("companyId");
    const noticeId = getQueryStringValue("noticeId");
    setCompanyId(companyId);
    setNoticeId(noticeId);
    GetCompanyById(companyId).then((p) => {
      console.log("cd", p.data.data);
      setCompanyData(p.data.data);
    });
    GetNoticeById(noticeId).then((p) => {
      console.log("dData", p.data);
      SetData(p.data);
    });
    GetNoticeDetailAnswereTableByGroupIdWithCompanyFilter(
      noticeId,
      companyId
    ).then((p: any) => {
      {
        console.log("dataAns", p.data.data);
        SetreportData(p.data.data);
      }
    });
    console.log("companyId", companyId);
    console.log("noticeId:", noticeId);
  }, []);

  return (
    <>
      <div
        dir="rtl"
        className="mt-2 ag-theme-alpine"
        style={{ width: "100%", height: 700 }}
      >
        <div dir="ltr" className="m-4">
          <AButton
            style={{
              backgroundColor: "green",
              color: "white",
              height: "3rem",
              width: "6rem",
              fontSize: "1.5rem",
            }}
            className="no-print my-2"
            onClick={handlePrint}
          >
            پرینت
          </AButton>
        </div>
        {CompanyId !== null &&
        NoticeId !== null &&
        data !== null &&
        data !== undefined ? (
          <>
            <div style={{ textAlign: "center" }}>
              <b>گزارش استعلام قیمت سامانه دیجیتال آگهی</b>
            </div>
            <div className="p-2" style={{ textAlign: "right" }}>
              بابت آگهی
              <b> {convertToPersianNumbers(data?.title)}</b>
            </div>
            <div className="p-2" style={{ textAlign: "right" }}>
              فروشگاه قیمت دهنده
              <b> {CompanyData?.name}</b>
            </div>
            <div className="p-2" style={{ textAlign: "right" }}>
              <b>تاریخ چاپ : </b>
              {convertToPersianNumbers(ConvertToShamsiWithOut330(new Date()))}
            </div>
            <div className="p-2">
              <table
                className="col-12   tr Counter"
                style={{
                  fontFamily: "Vazir",
                  textAlign: "center",
                  borderColor: "lightgray",
                }}
              >
                <th
                  style={{
                    writingMode: "vertical-rl",

                    paddingLeft: "6px",
                  }}
                >
                  #
                </th>
                <th style={{ verticalAlign: "middle" }}>نام و مشخصات کالا</th>
                <th style={{ verticalAlign: "middle" }}>تعداد/مقدار</th>
                <th style={{ verticalAlign: "middle" }}>واحد </th>
                <th style={{ verticalAlign: "middle" }}>مبلغ واحد</th>
                <th style={{ verticalAlign: "middle" }}>مبلغ کل</th>
                <th style={{ verticalAlign: "middle" }}>جمع مالیات و عوارض</th>
                <th style={{ verticalAlign: "middle" }}>خالص فاکتور</th>
                <th style={{ verticalAlign: "middle" }}>رنک</th>
                <th style={{ verticalAlign: "middle" }}>توضیحات</th>
                <th style={{ verticalAlign: "middle" }}>تاریخ اعلام قیمت</th>
                {data?.noticeDetails !== null &&
                data?.noticeDetails !== undefined ? (
                  <>
                    {data?.noticeDetails?.map((nd: any) =>
                      reportData !== null && reportData !== undefined ? (
                        <>
                          <tr className="numb" key={nd.id}>
                            <td>{nd.title}</td>
                            <td>
                              {Number(
                                reportData[
                                  reportData?.findIndex(
                                    (p: any) => p.noticeDetailId === nd.id
                                  )
                                ]?.count
                              ) < Number(nd?.count) ? (
                                <>
                                  {convertToPersianNumbers(
                                    reportData[
                                      reportData?.findIndex(
                                        (p: any) => p.noticeDetailId === nd.id
                                      )
                                    ]?.count
                                  )}
                                  {" از "}
                                  {convertToPersianNumbers(nd?.count)}
                                </>
                              ) : (
                                <>{convertToPersianNumbers(nd?.count)}</>
                              )}
                            </td>
                            <td>
                              {
                                Units[
                                  Units?.findIndex(
                                    (f: any) => f.value === nd.unit.toString()
                                  )
                                ]?.label
                              }
                            </td>
                            <td>
                              {convertToPersianNumbers(
                                reportData[
                                  reportData?.findIndex(
                                    (p: any) => p.noticeDetailId === nd.id
                                  )
                                ]?.price
                                  .toString()

                                  ?.replace(/[^0-9]/g, "")
                                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              )}
                            </td>
                            <td>
                              {convertToPersianNumbers(
                                reportData[
                                  reportData?.findIndex(
                                    (p: any) => p.noticeDetailId === nd.id
                                  )
                                ]?.totalPrice
                                  .toString()
                                  ?.replace(/[^0-9]/g, "")
                                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              )}
                            </td>
                            <td>
                              {convertToPersianNumbers(
                                reportData[
                                  reportData?.findIndex(
                                    (p: any) => p.noticeDetailId === nd.id
                                  )
                                ]?.totalVat
                                  .toString()
                                  ?.replace(/[^0-9]/g, "")
                                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              )}
                            </td>

                            <td>
                              {convertToPersianNumbers(
                                reportData[
                                  reportData?.findIndex(
                                    (p: any) => p.noticeDetailId === nd.id
                                  )
                                ]?.totalPriceWithVat
                                  ?.toString()
                                  ?.replace(/[^0-9]/g, "")
                                  ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              )}
                            </td>
                            <td>
                              {convertToPersianNumbers(
                                reportData[
                                  reportData?.findIndex(
                                    (p: any) => p.noticeDetailId === nd.id
                                  )
                                ]?.rank
                              )}
                            </td>
                            <td>
                              {convertToPersianNumbers(
                                reportData[
                                  reportData?.findIndex(
                                    (p: any) => p.noticeDetailId === nd.id
                                  )
                                ]?.description
                              )}
                            </td>
                            <td>
                              {convertToPersianNumbers(
                                ConvertToShamsi(
                                  reportData[
                                    reportData?.findIndex(
                                      (p: any) => p.noticeDetailId === nd.id
                                    )
                                  ]?.createDate
                                )
                              )}
                            </td>
                          </tr>
                        </>
                      ) : (
                        <></>
                      )
                    )}{" "}
                  </>
                ) : (
                  <> </>
                )}

                <tr>
                  <td colSpan={4}>جمع کل</td>

                  <td>
                    {convertToPersianNumbers(
                      Number(SumPrice)
                        ?.toString()
                        ?.replace(/[^0-9]/g, "")
                        ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    )}
                  </td>
                  <td>
                    {convertToPersianNumbers(
                      SumTotalPrice?.toString()
                        ?.replace(/[^0-9]/g, "")
                        ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    )}
                  </td>
                  <td style={{ fontFamily: "Vazir" }}>
                    {convertToPersianNumbers(
                      SumVat?.toString()
                        ?.replace(/[^0-9]/g, "")
                        ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    )}
                  </td>
                  <td>
                    {convertToPersianNumbers(
                      SumTotalPriceVat?.toString()
                        ?.replace(/[^0-9]/g, "")
                        ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    )}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
export default CompareTableNoticeDetailsVer1;
